import { render, staticRenderFns } from "./patrol-table.vue?vue&type=template&id=66750314"
import script from "./patrol-table.vue?vue&type=script&lang=js"
export * from "./patrol-table.vue?vue&type=script&lang=js"
import style0 from "./patrol-table.vue?vue&type=style&index=0&id=66750314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports